// @flow
import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  type DirectMerchants,
  type Currencies
} from '../../../../utilities/types';
import { setShowId, showTooltip, resetReferralsState } from '../reducer';
import DirectMerchantsIndexTable from '../../../Merchants/DirectMerchants/DirectMerchantsIndex/DirectMerchantsIndexTable';
import DirectMerchantsShow from '../../../Merchants/DirectMerchants/DirectMerchantsShow';
import { getMostRecentMerchants } from './selectors';

type Props = {
  resetReferralsState: () => void,
  directMerchants: DirectMerchants,
  showTooltip: (tooltip: string) => void,
  activeTooltip: ?string,
  currencies: Currencies,
  showId: number,
  setShowId: number => void,
  resetReferralsState: () => void,
  directMerchantsLoading: boolean,
  directMerchantsFailedLoad: boolean
};

class Merchants extends Component<Props> {
  render() {
    return this.props.showId ? (
      <DirectMerchantsShow
        showMostRecentOnly
        handleClick={this.props.resetReferralsState}
      />
    ) : (
      // $FlowFixMe
      <DirectMerchantsIndexTable
        directMerchants={this.props.directMerchants}
        loading={this.props.directMerchantsLoading}
        failedLoad={this.props.directMerchantsFailedLoad}
        showTooltip={this.props.showTooltip}
        activeTooltip={this.props.activeTooltip}
        currencies={this.props.currencies}
        showMostRecentOnly
        setActiveSubsection={this.props.setShowId}
      />
    );
  }
}

const mapStateToProps = state => ({
  showId: state.dashboard.referrals.showId,
  directMerchants: getMostRecentMerchants(state),
  directMerchantsLoading:
    state.merchants.directMerchants.index.directMerchants.loading,
  directMerchantsFailedLoad:
    state.merchants.directMerchants.index.directMerchants.failedLoad,
  currencies: state.global.currencies,
  activeTooltip: state.dashboard.referrals.activeTooltip
});

const mapDispatchToProps = {
  setShowId,
  showTooltip,
  resetReferralsState
};

export default connect(mapStateToProps, mapDispatchToProps)(Merchants);
